import { z } from 'zod';

export enum RichInputVariant {
  InlineEditing = 'inlineEditing',
  TextCellDisplay = 'textCellDisplay',
}

export const RichInputVariantSchema = z.nativeEnum(RichInputVariant);
